import { BiBrushAlt, BiData } from "react-icons/bi";
import { CiGrid42 } from "react-icons/ci";
import { IoSettingsOutline } from "react-icons/io5"
import { LuSticker } from "react-icons/lu";
import { LuLayoutGrid } from "react-icons/lu";
import { GrDocumentConfig } from "react-icons/gr";

const icon = { size: "24px" };

export const routes = {
  sidebarRoutes: [

    {
      name: "Home",
      path: "/homescreen",
      icon: <LuLayoutGrid  {...icon} />,
      items: [
        {
          name: "Home Screen",
          path: "/homescreen",
        },
        // {
        //   name: "Custom Section",
        //   path: "/customsection",
        // },
        // {
        //   name: "Functionality",
        //   path: "/functionality",
        // },
        {
          name: " Redirectional",
          path: "/redirectional",
        },
        // {
        //   name: "Ai Creation",
        //   path: "/triAi",
        // },
      ],
    },
    {
      name: "Themes",
      path: "/themestore",
      icon: <BiBrushAlt {...icon} />,

      items: [
        {
          name: "Theme Store",
          path: "/themestore",
        },
        {
          name: "Theme Categories",
          path: "/themecategories",
        },
        {
          name: "Theme Tags",
          path: "/themetags",
        },
        {
          name: "Theme Hashtags",
          path: "/themehashtags",
        },
        {
          name: "Theme Colors",
          path: "/themecolor",
        },
        {
          name: "Theme Comments",
          path: "/themecomment",
        },
        {
          name: "Theme Zip Validation",
          path: "/zip-validation",
        }, {
          name: "Theme Report Reason",
          path: "/reportreason",
        },
        {
          name: "Theme Reported Comments",
          path: "/reportedcomments",
        },
      ]
    },
    {
      name: "DIY's",
      path: "/backgrounds",
      icon: <CiGrid42 {...icon} />,

      items: [
        {
          name: "DIY Backgrounds",
          path: "/backgrounds",
        },
        {
          name: "DIY Background Categories",
          path: "/backgroundcategories",
        },
        {
          name: "DIY Effects",
          path: "/effects",
        },
        {
          name: "DIY Fonts",
          path: "/fontlists",
        },
        {
          name: "DIY Keys",
          path: "/keys",
        },
        {
          name: "DIY Keys Categories",
          path: "/keyscategories",
        },
        {
          name: "DIY Sounds",
          path: "/sounds",
        },
        {
          name: "DIY Lenses",
          path: "/lenses",
        },
        {
          name: "DIY Swipes",
          path: "/swipes",
        },
        {
          name: "DIY Auto",
          path: "/auto",
        },
        {
          name: "DIY Key json",
          path: "/keysjson",
        },
        {
          name: "DIY Lense json",
          path: "/lensejson",
        },
        {
          name: "DIY Auto json",
          path: "/autojson",
        },
      ]
    },
    {
      name: "Store",
      path: "/bannerstore",
      icon: <BiData  {...icon} />,

      items: [
        {
          name: "Banner Store",
          path: "/bannerstore",
        },
        {
          name: "Subscription Icon",
          path: "/subscriptionicon",
        },
      ]
    },
    {
      name: "AI Stickers",
      path: "/stickerpack",
      icon: <LuSticker  {...icon} />,

      items: [
        {
          name: "Sticker Pack",
          path: "/stickerpack",
        }
      ]
    },
    {
      name: "WhatsApp Sticker",
      path: "/stickerstore",
      icon: <LuSticker  {...icon} />,
      items: [
        {
          name: "Sticker Store",
          path: "/stickerstore",
        },
        {
          name: "Sticker Tag",
          path: "/stickertag",
        }
      ]
    },
    {
      name: "Settings",
      path: "/settings",
      icon: <IoSettingsOutline {...icon} />,
      items: [
        {
          name: "AI Config",
          path: "/settings",
        },
        {
          name: "Version",
          path: "/version",
        },
      ]
    },
    {
      name: "RC Config",
      path: "/rcconfig",
      icon: <GrDocumentConfig size="20px" />,
      items: [
        {
          name: "RC Config",
          path: "/rcconfig",
        },
      ],
    },
    {
      name: "History",
      path: "/history",
      icon: <IoSettingsOutline {...icon} />,
    },

  ],
};

export default routes;
